/**
 *
 * Component for Previewing reports
 *
 * @description
 * @author Sneha
 *
 */

import React, { useEffect, useState } from 'react';

import './print-preview.scss';

import axios from 'axios';

import { Card, ReferenceSelect, useTranslation, ApiUtils, PdfViewer } from 'soxo-bootstrap-core';

import { Button, Form, Skeleton, Empty, Modal, Radio, Input, Typography, Divider, message } from 'antd';

import { TemplateMasters, Bills, MedicalReports } from '../../../../models';

/**
 * Component for Sending the Report
 *
 * @returns
 */
export function PreviewButton({
    // Caption for the Preview Button
    caption = 'Preview',
    // Template code for preview of content
    templateCode,
    // Reference id of the record
    refereneceId,
    // Group Pointer, Alternate options for display of templates
    groupPointer,

    // Configuration for the Preview
    config = {},
    // template details
    templateDetails,
    isPdfPreviewMode,
    templateOtherDetails,
    html,
    checkPrint,
    //Attribute to manage send mail
    sendMail,
    ...props
}) {
    // Variable to show the preview
    const [open, setOpen] = useState(false);

    /**
     * Open the Modal for Preview
     */
    const viewReport = () => {
        setOpen(true);
    };

    return (
        <>
            <Button size="small" className="preview-report-trigger" type="dashed" onClick={viewReport}>
                {caption}
            </Button>

            {/* Modal for Viewing Report */}
            <Modal
                width={'80%'}
                height={'570px'}
                destroyOnClose={true}
                footer={null}
                title="Bill Preview"
                visible={open}
                cancelButtonProps={{ style: { display: 'none' } }}
                okText="Close"
                onOk={() => {
                    setOpen(false);
                }}
                onCancel={() => {
                    setOpen(false);
                }}
            >
                <PrintPreview
                    templatecode={templateCode}
                    refereneceId={refereneceId}
                    groupPointer={groupPointer}
                    props={props}
                    config={config}
                    sendMail={sendMail}
                    isPdfPreviewMode={isPdfPreviewMode}
                    html={html}
                    checkPrint={checkPrint}
                    templateOtherDetails={templateOtherDetails}
                />
            </Modal>
            {/* Modal for Viewing Report Ends */}
        </>
    );
}

/**
 *
 *
 * @param {*} param0
 * @returns
 */
export default function PrintPreview({
    refereneceId,
    //HTML content used to generate the PDF preview if isPdfPreviewMode is true
    html,
    //Flag to determine if the component should generate PDF from HTML
    isPdfPreviewMode,
    //Object with template metadata (like tmpl_desc and tmpl_otherdetails)
    templateDetails,

    checkPrint,
    groupPointer,
    templatecode,
    sendMail,
    props,
    config = {
        recipient: {},
    },
}) {
    // Extracting the recipient
    const { recipient } = config;

    const [initial, setInitial] = useState({
        email: recipient.email,
    });

    // Variable to convert BytesArray
    var [byteArray, setByteArray] = useState(null);

    const [reportModalVisible, setReportModalVisible] = useState(false);

    //Variable to handle button loading
    const [btnloading, setBtnLoading] = useState(false);

    //Variable to handle publish button loading
    // const [publishLoading, setPublishLoading] = useState(false);

    // Variable to disable and enable button
    const [disable, setDisable] = useState(true);

    const [blob, setBlob] = useState();

    const [reportBlob, setReportBlob] = useState();

    const [file, setFile] = useState();

    const [templateCode, setTemplateCode] = useState(templatecode);

    // State to hold the width and height extracted from the template styles
    // const [templateStyles, setTemplateStyles] = useState({ width: null, height: null });

    const [form] = Form.useForm();

    const [checked, setChecked] = useState(true);

    //Variable to handle button loading
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false);

    const { t, i18n } = useTranslation(); // To Translate to another language

    useEffect(() => {
        // loadLabResults(billId);
    }, []);
    console.log('template codeeeeeee', templateDetails);
    /**
     * This is done to preview pdf on first load
     */
    useEffect(() => {
        // preview();
        if (isPdfPreviewMode) {
            // Parse the 'tmpl_otherdetails' JSON string
            if (templateDetails.tmpl_otherdetails) {
                let parsed = JSON.parse(templateDetails.tmpl_otherdetails);
                // If parsed object has 'template_code', enable send button
                if (parsed && parsed.template_code) {
                    setDisable(false);
                }
            }

            createPdfPreviewFromHtml();
        } else {
            preview();
            setDisable(false);
        }
    }, []);

    /**
     *
     */
    async function createPdfPreviewFromHtml() {
        // Prepare the form body with the HTML content to be converted to PDF

        let formBody = {
            html: html,
        };
        // Set button loading state to true while processing

        setBtnLoading(true);
        // Store the Blob in state (if used for download/view)

        const response = await MedicalReports.previewReport(formBody);
        const report = new Blob([response.raw], { type: response.contentType });

        setBlob(report);

        setReportBlob(report);

        const fileURL = URL.createObjectURL(report, { type: 'application/pdf' });

        setFile(fileURL);
        // Construct metadata about the generated report

        let reportData = {
            report_url: fileURL,
            report_remote_path: response.url,
            report_remote_token: localStorage.access_token,
        };

        setByteArray(reportData.report_url);

        setBtnLoading(false);
    }

    /**
     * Function to update the form value
     *
     * @param {*} field
     * @param {*} value
     */
    function onUpdate(field, value) {
        // Update the form with value
        form.setFieldsValue(field, value);
    }

    /**
     * To Send the report
     */
    async function sendMessage(values) {
        setSubmitButtonLoading(true);
        let result;
        let formBody = {
            id: refereneceId,
            template_code: templateCode ? templateCode : templatecode,
            email: values.email,
            mode: values.mode,
            message_template: templateCode ? templateCode : templatecode,
        };

        if (isPdfPreviewMode) {
            // Parse the templateOtherDetails if it's a JSON string
            let parsed = JSON.parse(templateDetails.tmpl_otherdetails);

            // Create a new FormData object to send as multipart/form-data
            var form = new FormData();

            // Append the PDF blob as a file
            form.append('file', blob, templateDetails.tmpl_desc + '.pdf');
            // Specify that the method of sending is via email
            form.append('method', 'email');
            // Append the template_code from the parsed JSON
            form.append('template_code', parsed.template_code);

            // Append the recipient email from form values
            form.append('email', values.email); // dynamic email from form input
            form.append('reference_id', refereneceId);

            // Send the form data to the backend endpoint using Axios
            result = await axios.post(`${props.communicationBaseUrl}communication/send-message`, form, {
                headers: {
                    // Pass the tenant ID for multi-tenancy support
                    'X-TENANT-ID': props.tenantId,

                    // Set the Authorization header using token from localStorage
                    Authorization: 'Bearer ' + localStorage.access_token,
                },
            });

            // Get the actual response data
            result = result.data;
        } else {
            result = await ApiUtils.post({
                url: `reporting/send-preview`,
                formBody,
            });
        }

        setSubmitButtonLoading(false);

        if (result.success) {
            message.success(result.message);
        } else {
            message.error(result.message);
        }
    }

    /**
     * Function to preview result
     *
     *
     */
    async function preview(values) {
        // if (labResults.length && templateCode) {
        setBtnLoading(true);

        let formbody = {
            id: refereneceId,
            template_code: templateCode ? templateCode : templatecode,
        };

        // let method = 'GET'

        // let payload = {
        //     method: 'GET',
        //     responseType: 'blob',
        //     headers: {
        //         db_ptr: props.settings ? props.settings.headers.db_ptr.toString() : props,
        //         // db_ptr: 'nura',
        //         Authorization: 'Bearer ' + localStorage.access_token,
        //     },

        // };

        // let url = process.env.REACT_APP_endpoint + `reporting/print-preview`

        let response = await ApiUtils.post({
            url: `reporting/print-preview`,

            responseType: 'blob',

            formBody: formbody,
        });

        // await axios.post(`${url}`, formbody, payload)

        //     .then((res) => {

        // var report = new Blob([res], {

        //     type: 'application/pdf',

        // });

        // setBlob(report);

        // setReportBlob(report);

        // let fileURL = URL.createObjectURL(report);

        // setFile(fileURL);

        // Assuming response object has {contentType, raw} properties
        const report = new Blob([response.raw], { type: response.contentType });

        setBlob(report);

        setReportBlob(report);

        const fileURL = URL.createObjectURL(report, { type: 'application/pdf' });

        setFile(fileURL);

        let reportData = {
            report_url: fileURL,
            report_remote_path: response.url,
            report_remote_token: localStorage.access_token,
        };

        setByteArray(reportData.report_url);

        setBtnLoading(false);

        // })
        // .catch(() => ({

        //     error: true,

        //     data: null,
        // }))
    }

    /**
     *  Load default Template
     * @param {*} options
     * @returns
     */
    function identifyDefaultTemplate(options = []) {
        let matching = {};

        //To load lab report as default template
        if (options) {
            options.forEach(async (record) => {
                if (record.tmpl_code === templatecode) {
                    matching = record;

                    // Extract width and height from template styles
                    // const templateDetails = JSON.parse(matching.tmpl_otherdetails);
                    // const styles = templateDetails.styles[0];
                    // setTemplateStyles({
                    //     width: styles.width,
                    //     height: styles.height
                    // });
                }
            });
        }

        if (matching) {
            setTemplateCode(matching.tmpl_code);
            return matching;
        }
    }

    /**
     * View the Report
     */

    function viewReport() {
        setReportModalVisible(true);
    }

    function selectedCode(event) {
        setTemplateCode(event);
    }

    return (
        <div className="detail-contents">
            {checkPrint && !sendMail ? null : (
                <div className="left-sections">
                    <div className="top">{/* <Button onClick={viewReport}>print</Button> */}</div>

                    <div className="bottom">
                        <Card className="card-shadow card" loading={() => <Skeleton />}>
                            {/* Preview Action Form */}
                            {/* <Form onFinish={preview} form={form}> */}
                            <Form onFinish={sendMessage} form={form} layout="vertical" initialValues={{ ...initial }}>
                                {isPdfPreviewMode ? null : (
                                    <>
                                        {/* Template Code */}
                                        <Form.Item name="template_code" label="Template">
                                            <ReferenceSelect
                                                config={{
                                                    // limit: 50,
                                                    queries: [
                                                        {
                                                            field: 'tmpl_groupptr',
                                                            value: groupPointer,
                                                        },
                                                        {
                                                            field: 'tmpl_active',
                                                            value: 'Y',
                                                        },
                                                    ],
                                                }}
                                                defaultValueCondition={identifyDefaultTemplate}
                                                onChange={selectedCode}
                                                field="tmpl_code"
                                                label="tmpl_desc"
                                                mode="nura-base"
                                                model={TemplateMasters}
                                            />
                                        </Form.Item>
                                        {/* Template Code Ends */}

                                        <Button
                                            size="small"
                                            onClick={preview}
                                            disabled={disable}
                                            loading={btnloading}
                                            className="preview-button"
                                            type="secondary"
                                        >
                                            Preview
                                        </Button>
                                    </>
                                )}
                                {/* If the attribute is true the button will show */}
                                {sendMail ? (
                                    <>
                                        <Divider plain>SEND VIA</Divider>

                                        <Form.Item valuePropName="checked">
                                            <Radio checked={checked}>Email</Radio>
                                        </Form.Item>

                                        <Form.Item name="email">
                                            {!props.isEmailEditable ? (
                                                <Input
                                                    type="email"
                                                    // value={recipient}
                                                    onChange={(e) => onUpdate('email', e.target.value)}
                                                />
                                            ) : (
                                                <Input
                                                    type="email"
                                                    // value={recipient}
                                                    readOnly
                                                />
                                            )}
                                        </Form.Item>

                                        <Form.Item>
                                            <Button
                                                disabled={disable}
                                                loading={submitButtonLoading}
                                                className="preview-button"
                                                type="primary"
                                                htmlType="submit"
                                            >
                                                Send
                                            </Button>
                                        </Form.Item>
                                    </>
                                ) : null}
                                {/*  */}
                            </Form>

                            {/* Preview Action Form */}
                            {/* <Select className='select-action' placeholder="- Select Action -" /> */}
                        </Card>

                        {/* Modal for Viewing Report */}
                        <Modal
                            width={'80%'}
                            heigh={'570px'}
                            destroyOnClose={true}
                            footer={null}
                            title={t('Bill Preview')}
                            visible={reportModalVisible}
                            cancelButtonProps={{ style: { display: 'none' } }}
                            okText="Close"
                            onOk={() => {
                                setReportModalVisible(false);
                            }}
                            onCancel={() => {
                                setReportModalVisible(false);
                            }}
                        ></Modal>
                    </div>
                </div>
            )}
            <div className="right-sections">
                {/* Report Preview */}
                {byteArray || btnloading ? (
                    <div className="report-container">
                        {btnloading ? (
                            <>
                                <Skeleton />
                            </>
                        ) : (
                            <div>
                                <PdfViewer url={byteArray} />
                                {/* Iframe to display the PDF preview with dynamic width and height from template styles */}
                                {/* <iframe src={byteArray} title='preview' style={{ width: templateStyles.width, height: templateStyles.height }} />                             */}
                                {/* <iframe src={byteArray} style={{ width: '100%', height: '573px' }} /> */}
                            </div>
                        )}
                    </div>
                ) : (
                    <Empty />
                )}
                {/* Report Preview Ends */}
            </div>
        </div>
    );
}
